import React, { useEffect, useLayoutEffect, useState } from "react";
import WebHookReceiverLogsAuditItem from "./WebHookReceiverLogsAuditItem";
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { getWebhookReceiverLogAuditDatatableAsync,resetSelectedRecordObjectInState,setPageSize,setSortConfig,setSearchValue } from './WebHookReceiverLogsAuditSlice';
import Select, { StylesConfig } from 'react-select';
import CustomPagination from "../../../common/Pagination";
import { useDebounce } from "../../../_metronic/helpers";
import { ShowToast } from "../../../common/Toastr";
import { updatePageIdState, getPagePermissionsAsync,getParentPagePermissionsAsync } from '../../../common/GlobalSlice';

const colourStyles: StylesConfig = {
    control: (styles) => ({ ...styles, backgroundColor: 'white', width: 75, minHeight: '36px', height: '36px', padding: '-1px', borderColor: '#EBECF0', marginRight: '0px', fontWeight: '400px', color: '#172B4F' })
}

const WebHookReceiverLogsAudit = () => {
    
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const webhookreceiverlogid = params.get('WebhookReceiverLogId');
    const { t } = useTranslation();
    // const [searchTerm, setSearchTerm] = useState('');
    const dispatch = useAppDispatch();
    const { WebHookReceiverLogsAuditList, isReload,currentPage ,pageSize,totalItems,start,search,sortDirection,sortIndex ,recordsFiltered,isSearch} = useAppSelector((state) => state.webHookReceiverLogAudit);
    const options = [{ value: '10', label: '10' }, { value: '20', label: '20' }, { value: '30', label: '30' }, { value: '40', label: '40' }, { value: '50', label: '50' }];
    const navigate = useNavigate();
    const {  menuList, IsList, IsAdd, IsEdit, IsDelete } = useAppSelector((state) => state.globalState);


    const parentPageId: string = '186';
    const pageId: string = '185';
    
    
    useLayoutEffect(() => {
        const fetchPagePermissions = async () => {
            if (pageId && pageId !== '') {
                const res = await dispatch(getPagePermissionsAsync(pageId));
                if (!res.payload.IsList) {
                    navigate('../error/403');
                }
            }
        };
        const fetchParentPagePermissions = async () => {
            if (parentPageId && parentPageId !== '') {
                const res = await dispatch(getParentPagePermissionsAsync(parentPageId));
                if (!res.payload.IsList) {
                    navigate('../error/403');
                }
                else {
                    fetchPagePermissions();
                }
            }
        };
        fetchParentPagePermissions();
    }, [dispatch, location.pathname, menuList, navigate, pageId]);

    useEffect(() => {
        if(webhookreceiverlogid !== null)
        {
            if(isGuid(webhookreceiverlogid))
            {
                dispatch(getWebhookReceiverLogAuditDatatableAsync({webhookreceiverlogid:webhookreceiverlogid,currentPage: currentPage,pageSize: pageSize,start:start, order: sortIndex, orderDir: sortDirection,search:""}));
            }
            else
            {
                navigate('/webHookReceiverLogs');
            }
        }
        else
        {
            navigate('/webHookReceiverLogs');
        }
        
    }, [dispatch])

    const isGuid = (stringToTest:any) => {
        if (stringToTest[0] === "{") {
            stringToTest = stringToTest.substring(1, stringToTest.length - 1);
        }
        var regexGuid = /^(\{){0,1}[0-9a-fA-F]{8}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{12}(\}){0,1}$/gi;
        var x = regexGuid.test(stringToTest);
        return x;
    };

    const handleSearch = (event: any) => {
        const { value } = event.target;
        if (value !== ' ') {
            dispatch(setSearchValue(value));
        }
    };

    const handlePageSizeChange = (event: any) => {
        const { value } = event;
        dispatch(setPageSize(Number(value)));
       dispatch(getWebhookReceiverLogAuditDatatableAsync({webhookreceiverlogid:webhookreceiverlogid,currentPage: 1,pageSize: value,start:0, order: sortIndex, orderDir: sortDirection,search:" "}));
    };

    const handlePageChange = (pageNumber: any) => {
        const start = (pageNumber - 1) * pageSize;
        dispatch(getWebhookReceiverLogAuditDatatableAsync({webhookreceiverlogid:webhookreceiverlogid,currentPage: pageNumber,pageSize: pageSize,start:start, order: sortIndex, orderDir: sortDirection,search:" "}));
    };

    const debouncedSearchTerm = useDebounce(search, 500);

    useEffect(() => {
        if (isSearch && debouncedSearchTerm !== ' ') {
            dispatch(getWebhookReceiverLogAuditDatatableAsync({ currentPage: 1, pageSize: pageSize, start: 0, order: sortIndex, orderDir: sortDirection, search: debouncedSearchTerm }));
        }

    }, [debouncedSearchTerm]);

    return (
        <>
              <div className="card card-custom admin-card">
                <div className="card-header sticky-top bg-white">
                    <h3 className="card-title fw-bold mainHeading" >{t('Webhook Receiver Logs Audit')}</h3>
                    <div className="card-toolbar align-items-center">
                        <div className="position-relative">
                            <input
                                type="text"
                                value={search}
                                onChange={handleSearch}
                                placeholder={t('Search')}
                                className="form-control h-35px w-200px fs-7 fw-normal pr-4"
                                data-kt-user-table-filter="search"

                            />
                            <i className="ki-duotone ki-magnifier fs-5 position-absolute top-50 translate-middle-y end-0" style={{ marginRight: '10px' }}  >
                                <span className="path1"></span>
                                <span className="path2"></span>
                            </i>
                        </div>
                        <div className='h-35px w-1px mx-1'></div>
                        <div className="d-flex align-items-center">
                            <Select
                                styles={colourStyles}
                                options={options}
                                value={options.find(option => parseInt(option.value) == pageSize)}
                                onChange={handlePageSizeChange}
                                className='fs-7 fw-normal'

                            />
                        </div>

                        <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                        <div>
                       
                          {(WebHookReceiverLogsAuditList.length > 0) ? (
                                <CustomPagination
                                    currentPage={currentPage}
                                    onPageChange={handlePageChange}
                                    pageSize={pageSize}
                                    totalItems={totalItems}
                                    start={(currentPage - 1) * pageSize}
                                    t={t}
                                    recordsFiltered={recordsFiltered}
                                >
                                </CustomPagination>
                            ) : null}
                        </div>
                    </div>
                </div>
                {IsList && 
                <div className="card-body">
                    <div className="table-responsive">
                        <WebHookReceiverLogsAuditItem WebHookReceiverLogsAuditList={WebHookReceiverLogsAuditList}  webhookreceiverlogid={webhookreceiverlogid} t={t} />
                    </div>
                </div>
                }
            </div>
        </>
    )
}

export default WebHookReceiverLogsAudit;
